export default "__VITE_ASSET__e1ba417d__"